import { fetchChatMessages } from 'actions/supportAssistant/supportAssistantActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import useTabVisibility from 'hooks/useTabVisibility'
import { selectLoggedIn } from 'selectors/accountSelectors'

function useChatMessages(chatId: string): [Array<App.ChatMessage>, boolean, any ] {
  const appDispatch = useAppDispatch()
  const isTabVisible = useTabVisibility()

  const loggedIn = useAppSelector(selectLoggedIn)
  const messages = useAppSelector(state => state.supportAssistant.messages[chatId]) ?? []
  const messagesLoading = useAppSelector(state => state.supportAssistant.messagesLoading[chatId])
  const messagesError = useAppSelector(state => state.supportAssistant.messagesError[chatId])

  useEffect(() => {
    // we want to trigger the reload of messages when the user returns to the support page.
    // This is so that responses to actions that redirect to an external page get loaded on return.
    if (loggedIn && isTabVisible && chatId !== 'default') {
      appDispatch(fetchChatMessages())
    }
  }, [appDispatch, chatId, isTabVisible, loggedIn])

  return [
    messages,
    messagesLoading,
    messagesError,
  ]
}

export default useChatMessages
